<template>
    <span>
        <el-badge>
            <el-tooltip class="item" effect="dark" :content="`启动系统全部监听`" placement="top-start">
                <el-button title="全部开始" class="green" icon="el-icon-fa-play" @click="handleStart">全部开始</el-button>
            </el-tooltip>
        </el-badge>
        <el-badge class="margin-left-1">
            <el-tooltip class="item" effect="dark" :content="`停止系统全部监听`" placement="top-start">
                <el-button title="全部停止" class="red" icon="el-icon-fa-stop" @click="handleStop">全部停止</el-button>
            </el-tooltip>
        </el-badge>
    </span>
</template>

<script>
import { PageTable } from 'cnetong-core-frontend';
import HeaderApi from "../Header";

export default {
    data: () => ({
        pageTable: new PageTable({
            doLoad: '',
            autoLoad: false
        })
    }),
    methods: {
        async handleStart() {
            await this.confirm();
            await HeaderApi.startAll();
            await this.$store.dispatch('trigger')
            this.$message.success('启动成功');
        },
        async handleStop() {
            await this.confirm();
            await HeaderApi.stopAll();
            await this.$store.dispatch('trigger')
            this.$message.success('停止成功');
        },
    }
}
</script>

<style scoped>

</style>